module.exports = __webpack_public_path__ + "img/camp05_close.bbfe3f9d.png";